/* global axios */

import ApiClient from './ApiClient';

// ACESSO-01 (L8a): o catálogo de acesso da conta (`Acesso::CatalogoController`): os módulos, os escopos, os grupos (os
// da Powerbizz e os da conta) e os modelos, com o rótulo e a frase no idioma de quem pede. Só leitura, de todo membro.
class AcessoAPI extends ApiClient {
  constructor() {
    super('acesso', { accountScoped: true });
  }

  catalogo() {
    return axios.get(`${this.url}/catalogo`);
  }
}

export default new AcessoAPI();
